const Logo = () => {
    return <svg width="67" height="40" viewBox="0 0 67 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_0_1)">
            <path d="M14.8161 7.16205C14.8161 12.0459 10.6279 17.6859 5.46157 17.6859C0.295214 17.6859 1.00355 15.1884 1.00355 10.3046C1.00355 5.42076 0.295214 0 5.46157 0C10.6279 0 14.8161 2.27823 14.8161 7.16205Z" fill="#B627C2" />
            <path d="M17.195 24.7018C17.195 29.5856 10.1024 30.4752 4.93608 30.4752C-0.230272 30.4752 0.899059 26.5161 0.899059 21.6323C0.899059 16.7485 -0.230272 12.7894 4.93608 12.7894C10.1024 12.7894 17.195 19.8179 17.195 24.7018Z" fill="#2778C2" />
        </g>
        <rect x="19.9721" y="14.4702" width="3.80027" height="15.9319" rx="1.90013" fill="#2778C2" />
        <rect x="29.4727" y="1.16931" width="3.80027" height="29.2328" rx="1.90013" fill="#B627C2" />
        <rect x="29.4727" y="1.16931" width="3.80027" height="29.2328" rx="1.90013" fill="#B627C2" />
        <rect x="29.4727" y="1.16931" width="3.80027" height="29.2328" rx="1.90013" fill="#B627C2" />
        <rect x="39.2658" y="1.16931" width="3.80027" height="29.2328" rx="1.90013" fill="#B627C2" />
        <rect x="39.2658" y="1.16931" width="3.80027" height="29.2328" rx="1.90013" fill="#B627C2" />
        <rect x="39.2658" y="1.16931" width="3.80027" height="29.2328" rx="1.90013" fill="#B627C2" />
        <rect x="45.5903" y="18.147" width="3.80027" height="15.9319" rx="1.90013" transform="rotate(-45 45.5903 18.147)" fill="#2778C2" />
        <rect x="63.5558" y="14.4702" width="3.80027" height="26.6941" rx="1.90013" transform="rotate(25 63.5558 14.4702)" fill="#2778C2" />
        <path d="M25.3071 9.31796C25.3071 11.2352 23.7529 12.7894 21.8357 12.7894C19.9185 12.7894 18.3643 11.2352 18.3643 9.31796C18.3643 7.40076 19.9185 5.84656 21.8357 5.84656C23.7529 5.84656 25.3071 7.40076 25.3071 9.31796Z" fill="#2778C2" />
        <defs>
            <filter id="filter0_d_0_1" x="0.209899" y="0" width="17.5697" height="31.6446" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset dy="0.584657" />
                <feGaussianBlur stdDeviation="0.292328" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape" />
            </filter>
        </defs>
    </svg>





}
export default Logo